import React, { useState } from "react";
import { z } from "zod";
import { SubmitHandler } from "react-hook-form";
import Button from "~/common/Buttons";
import Form from "~/common/Form";
import Input from "~/common/Form/Input";
import SubmissionResult from "../Shared/SubmissionResult";
import { EmailSignupEndpointResponse } from "../utilities";
interface EmailSignupFormFields {
  emailaddress: string;
}
interface BlogCouponCodesSignupProps {
  containerClasses?: string;
}
export default function BlogCouponCodesSignup({
  containerClasses = "w-3/4"
}: Readonly<BlogCouponCodesSignupProps>) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);
  const validationSchema = z.object({
    emailaddress: z.string().nonempty({
      message: "Email is required"
    }).email({
      message: "Email is an invalid format"
    })
  });
  const onSubmit: SubmitHandler<EmailSignupFormFields> = async (data, event) => {
    event?.preventDefault();
    setIsSubmitting(true);
    const formData = new URLSearchParams();
    Object.entries(data).forEach(entry => {
      formData.append(entry[0], entry[1]);
    });
    formData.append("signupFromPage", "Blog");
    try {
      const request = await fetch("/api/subscribetoallemails", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData
      });
      const response = await request.json<EmailSignupEndpointResponse>();
      if (response.statusCode === 200) {
        setIsSubmitting(false);
        setSubmitted(true);
        setSubmissionSuccessful(true);
        return;
      }
    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error(exception);
    }
    setIsSubmitting(false);
    setSubmitted(true);
    setSubmissionSuccessful(false);
  };

  // Using this declaration because declaring textWrap as an inline style throws a TS error
  const buttonStyleProps = {
    height: 42,
    textWrap: "nowrap"
  };
  return <div data-module="blogCouponCodesSignup" data-sentry-component="BlogCouponCodesSignup" data-sentry-source-file="BlogCouponCodesSignup.tsx">
      {submitted ? <div className="m-0 mx-auto mb-8 w-4/5">
          <SubmissionResult success={submissionSuccessful} />
        </div> : <Form<EmailSignupFormFields> validationSchema={validationSchema} onSubmit={onSubmit}>
          <div className={`flex my-6 mx-auto ${containerClasses}`}>
            <div className="flex-auto" style={{
          zIndex: 1
        }}>
              <Input label="" name="emailaddress" placeholder="Email Address" errorText="Email Address" type="email" labelClassName="mb-0" />
            </div>
            <div className="flex-initial" style={{
          zIndex: 2,
          marginLeft: -4
        }}>
              <Button type="submit" disabled={isSubmitting} color="blue" size="large" className="rounded-l-none rounded-r-md py-0 text-sm-1/2 lt:px-6 lz:px-8" style={buttonStyleProps}>
                Sign Up
              </Button>
            </div>
          </div>
        </Form>}
    </div>;
}